import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-modal',
  templateUrl: './general-modal.page.html',
  styleUrls: ['./general-modal.page.scss'],
})
export class GeneralModalPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
